import { render, staticRenderFns } from "./ElementFileExtra.vue?vue&type=template&id=1fceded9"
import script from "./ElementFileExtra.vue?vue&type=script&lang=ts"
export * from "./ElementFileExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports